import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=a6236330&scoped=true&"
import script from "./manage.vue?vue&type=script&lang=js&"
export * from "./manage.vue?vue&type=script&lang=js&"
import style0 from "./manage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./manage.vue?vue&type=style&index=1&id=a6236330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6236330",
  null
  
)

export default component.exports